
export default {
    name: 'LeeCells',
    data() {
        return {

        }
    },
    methods: {

    },
    props: {
        title: {
            type: String,
            default: '' //默认default
        },
        footer: {
            type: String,
            default: '' //默认default
        }
    }
};
